import { render } from "./WoWirSind.vue?vue&type=template&id=4550dd4f"
import script from "./WoWirSind.vue?vue&type=script&lang=ts"
export * from "./WoWirSind.vue?vue&type=script&lang=ts"

import "./WoWirSind.vue?vue&type=style&index=0&id=4550dd4f&lang=scss"
script.render = render

export default script